// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eb4bbf25","239":"73850b33","453":"ed3810f9","732":"a1e6e011"}[chunkId] + ".chunk.js";
};